import { FC, useContext, useEffect } from 'react';
import { FileSystemContext } from '.';
import apiUrl from '../../assets/apiUrl';
import { getAccessToken } from '../Auth';

const UpdatesListener: FC = ({ children }) => {
    const { useFiles, useFolders } = useContext(FileSystemContext);
    const [files, setFiles] = useFiles();
    const [folders, setFolders] = useFolders();
    useEffect(() => {
        const socket = new WebSocket(
            `${apiUrl}/updates`
                .replace('https://', 'wss://')
                .replace('http://', 'ws://')
        );

        socket.addEventListener('open', (event) => {
            getAccessToken().then((res) => socket.send('ACCESS_TOKEN ' + res));
        });
        socket.addEventListener('close', (event) => {
            clearInterval(pingHandle);
            clearInterval(accessTokenRefreshHandle);
        });

        const ping = () => socket.send('PING');
        const pingHandle = setInterval(ping, 5000);
        const refreshAccessToken = async () =>
            socket.send(`ACCESS_TOKEN ${await getAccessToken()}`);
        const accessTokenRefreshHandle = setInterval(
            refreshAccessToken,
            300000
        );
        socket.addEventListener('message', function (event) {
            if (event.data === 'AUTHENTICATED') return;
            try {
                const parsed = JSON.parse(event.data);
                if (parsed.resource === 'FILE') {
                    switch (parsed.method) {
                        case 'POST': {
                            setFiles((state) => {
                                if (
                                    state.find(
                                        (e) =>
                                            e.file_uid ===
                                            parsed.payload.file_uid
                                    )
                                )
                                    return state;
                                return [...state, parsed.payload];
                            });
                            break;
                        }
                        case 'DELETE': {
                            setFiles((state) =>
                                state.filter(
                                    (e) =>
                                        e.file_uid !== parsed.payload.file_uid
                                )
                            );
                            break;
                        }
                        case 'PUT': {
                            setFiles((state) => {
                                return state.map((e) =>
                                    e.file_uid === parsed.payload.file_uid
                                        ? parsed.payload
                                        : e
                                );
                            });
                            break;
                        }
                    }
                } else if (parsed.resource === 'FOLDER') {
                    switch (parsed.method) {
                        case 'POST': {
                            setFolders((state) => {
                                if (
                                    state.find(
                                        (e) =>
                                            e.folder_uid ===
                                            parsed.payload.folder_uid
                                    )
                                )
                                    return state;
                                return [...state, parsed.payload];
                            });
                            break;
                        }
                        case 'DELETE': {
                            setFolders((state) =>
                                state.filter(
                                    (e) =>
                                        e.folder_uid !==
                                        parsed.payload.folder_uid
                                )
                            );
                            break;
                        }
                        case 'PUT': {
                            setFolders((state) => {
                                return state.map((e) =>
                                    e.folder_uid === parsed.payload.folder_uid
                                        ? parsed.payload
                                        : e
                                );
                            });
                            break;
                        }
                    }
                }
            } catch (err) {}
        });

        return () => {
            socket.close();
            clearInterval(pingHandle);
            clearInterval(accessTokenRefreshHandle);
        };
    }, []);
    return <>{children}</>;
};

export default UpdatesListener;
